import React from "react";
import { useTranslation } from "react-i18next";
import Contact from "../Home/Contact";
import ExpoMedia from "../ExpoMedia";
import { Helmet } from "react-helmet-async";
import { useTranslatedVideos } from "./WorkVideos";
import Seoimg from "../../Assets/ServiceImg/works.webp";
import ServiceInfo from "./ServiceInfo";
import { useLocation } from "react-router-dom";

const Works = () => {
   const { t } = useTranslation();
   const videos = useTranslatedVideos();

   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

      const seoTranslations = {
         es: {
            title: "Trabajos con drones | Joan Company",
            description:
               "Descubre mis proyectos profesionales con drones: vuelos FPV inmersivos, grabaciones aéreas para inmobiliarias, cobertura de eventos, contenido visual creativo y mucho más.",
            keywords:
               "drones, fpv, grabación con drones, filmación con drones, fotografía aérea, videografía aérea, servicios con drones, grabación fpv, inmobiliaria con drones, eventos con drones, inspecciones técnicas con drones",
            canonical: "https://www.joancompany.es/trabajos",
         },
         en: {
            title: "Drone Works in Mallorca | Joan Company",
            description:
               "Discover my professional drone projects: immersive FPV flights, aerial recordings for real estate, event coverage, creative visual content and much more.",
            keywords:
               "drones, fpv, drone recording, drone filming, aerial photography, aerial videography, drone services, fpv recording, real estate with drones, events with drones, technical inspections with drones",
            canonical: "https://www.joancompany.es/en/trabajos",
         },
      };
   
   return (
      <div className="works">
         <Helmet>
            <title key="title">{seoTranslations[selectedLanguage].title}</title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link
               rel="canonical"
               href={seoTranslations[selectedLanguage].canonical}
            />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content={seoTranslations[selectedLanguage].title}
            />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].description}
            />
            <link rel="image_src" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/trabajos"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/trabajos"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <ServiceInfo
            title={t("works")}
            image={Seoimg}
            subtitle={t("works_desc")}
            description={t("works_desc")}
         />
         <div className="works-content">
            <ExpoMedia data={videos} />
         </div>
         <Contact />
      </div>
   );
};

export default Works;
